import { render, staticRenderFns } from "./SessionsCalendar.vue?vue&type=template&id=5f8e8009&scoped=true"
import script from "./SessionsCalendar.vue?vue&type=script&lang=js"
export * from "./SessionsCalendar.vue?vue&type=script&lang=js"
import style0 from "./SessionsCalendar.vue?vue&type=style&index=0&id=5f8e8009&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8e8009",
  null
  
)

export default component.exports